module.exports = __webpack_public_path__ + "media/images/LikePlaylist-1b6a3265.jpg";